var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.active ? 'active' : ''},[_c('nuxt-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2),_vm._v(" "),_vm._t("child")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }